import { isExternalContent } from "~/features/configurator/Linear/hooks/useExternalContent";
import { resolveUrlLanguage } from "~/features/configurator/Linear/components/LanguageAwareExternalContent";
import { requestExternalContent } from "~/features/externalContent/redux/actions";
import { type RootState } from "~/app/store";
import { type AnyAction } from "~/app/store/types";
import { type ThunkAction } from "redux-thunk";
import { removeDivTags, removePTags, removeSpanTags, removeTags } from "~/common/utils/domUtils";
import type { SummaryDataProvider } from "~/features/configurator/Shaft/SummaryDataProvider";

type ThunkResult<R> = ThunkAction<R, RootState, undefined, AnyAction>;
export function grabExternalTranslation(key: string): ThunkResult<Promise<string>> {
  return async (dispatch, getState) => {
    if (isExternalContent(key)) {
      key = resolveUrlLanguage(key, "en")!;
      let text = await dispatch(requestExternalContent(key));
      text = text!.trim();
      text = removeInternalNewlinesAndMultispaces(text);
      text = removePTags(text)!;
      text = removeDivTags(text)!;
      text = removeSpanTags(text)!;
      return text;
    }

    return key;
  };
}

const removeInternalNewlinesAndMultispaces = (text: string) => {
  return text.replace(/[\r\n]/gim, " ").replace(/  +/gim, " ");
};

export function grabXmlTranslation(summaryDataProvider: SummaryDataProvider, key: string) {
  let text = summaryDataProvider.t(key);
  text = text!.trim();
  text = removeInternalNewlinesAndMultispaces(text);
  text = removePTags(text)!;
  text = removeDivTags(text)!;
  text = removeSpanTags(text)!;
  text = removeTags(text, "h6")!;
  return text;
}
